import { useEffect, useState } from "react";
import apiHelper from "../ApiHelpar/apiHelper";
import useDebounce from "../useDebounce/useDebounce";

// const CheckUsername = ({ user, handleChange }) => {
//   const [error, setError] = useState("");
//    const [loading, setLoading] = useState(false);
//   const username = user?.customerId?.username || "";
//   const debouncedUsername = useDebounce(username, 500);

//   useEffect(() => {
//     setLoading(true)
//     const checkUsernameAvailability = async () => {
//       if (!debouncedUsername) return;

//       try {
//         const data = {
//           username: debouncedUsername,
//         };
//         const response = await apiHelper("checkUserName", data);

//         console.log(response.respData.message);

//         if (response.respData.message == "Username already exists") {
//           setError(response.respData.message);
//           // Clear the input field by updating parent state
//         //   handleChange({
//         //     target: {
//         //       name: "customerId.username",
//         //       value: "",
//         //     },
//         //   });
//         } else {
//           setError("");
//         }
//       } catch (err) {
//         console.error("Username check failed:", err);
//         setError("Error checking username availability");
//       }finally{
//         setLoading(false)
//       }
//     };

//     checkUsernameAvailability();
//   }, [debouncedUsername, handleChange]);

//   return (
//     <div className="form-group">
//       <input
//         type="text"
//         name="customerId.username"
//         value={username}
//         onChange={handleChange}
//         className={`form-control ${error ? "is-invalid" : ""}`}
//         placeholder="Enter username"
//         required
//       />
//       {error && <div className="invalid-feedback">{error}</div>}
//     </div>
//   );
// };

// export default CheckUsername; // Fixed component export name



const CheckUsername = ({ value, handleChange, name }) => {
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const username = value || "";
  const debouncedUsername = useDebounce(username, 500);


  

  useEffect(() => {
    const checkUsernameAvailability = async () => {
      if (!debouncedUsername) {
        setError("");
        return;
      }

      try {
        const response = await apiHelper("checkUserName", {
          username: debouncedUsername,
        });

        if (response.respData.message === "Username already exists") {
          setError(response.respData.message);
          //   handleChange({
          //     target: {
          //       name: "customerId.username",
          //       value: "",
          //     },
          //   });
        } else {
          setError("");
        }
      } catch (err) {
        console.error("Username check failed:", err);
        setError("Error checking username availability");
      } finally {
        setLoading(false);
      }
    };

    checkUsernameAvailability();
  }, [debouncedUsername, handleChange]);

  return (
    <div className="form-group position-relative">
      <input
        type="text"
        name={name}
        value={username}
        onChange={handleChange}
        className={`form-control ${error ? "is-invalid" : ""} ${
          loading ? "pe-5" : ""
        }`}
        placeholder="Enter username"
        required
        disabled={loading}
      />

      {loading && (
        <div className="position-absolute end-0 top-50 translate-middle-y me-2">
          <div
            className="spinner-border spinner-border-sm text-secondary"
            role="status"
          >
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      )}

      {error && <div className="invalid-feedback">{error}</div>}
    </div>
  );
};

export default CheckUsername;